export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_m2.f071a29e.jpg";